<template>
  <v-container>
    <v-row dense>
       <v-col cols="12" class="d-flex justify-center">
        <div class="text-h4 font-weight-bold">Producción Pesquera</div>
      </v-col>
      <v-col cols="12" class="pb-3">
        <div class="text-h7">Presiona el botón para agregar una pesca como peces, crustaceos, moluscos, etc </div>
      </v-col>
      <v-col v-if="user_can.add" cols="6">
        <v-btn router to="/ru/pesca" depressed class="primary">
          <v-icon left>mdi-plus</v-icon>
          Agrega pescas
        </v-btn>
      </v-col>

      <v-col v-if="user_can.add" cols="6">
        <v-btn router to="/ru/embarcaciones" depressed class="primary">
          <v-icon left>mdi-plus</v-icon>
          Agrega Embarcaciones
        </v-btn>
      </v-col>


      <v-col cols="12" class="tt">
        <div class="text-h6">Lista de mis pescas</div>
        <div class="text-h8">Presione la pesca para agregar Ventas, pesca o modificarlas</div>
      </v-col>
      <!-- Fila de espaciado -->
      <v-col cols="12" class="py-5"></v-col>
       <!-- Puedes ajustar py-5 a py-3 o py-2 según el espacio que prefieras -->
      <!-- Mensaje si no hay fincas -->
      <v-col v-if="Object.keys(pescas).length === 0" cols="12">
        <div class="text-body-1 text-center font-italic">
          Aún no tienes ninguna pesca 
        </div>
      </v-col>
      <!-- listado de actividades pesqueras en el almacenamiento local 
      `Embarcación ${embarcaciones[pesca.id_embarcacion].nombre ||   -->
      <v-col cols="12" class="lista">
        <v-list three-line>
          <template v-for="pesca in pescas">
            <form-card
              :key="pesca.id"
              :top-text="`Embarcación ${
                pesca.id_embarcacion.nombre || 'sin nombre...'
              }`"
              :bottom-right-text="producerDescription(pesca.productor)"
              :middle-text="`Ciclo ${pesca.ciclo}`"
              :top-right-text="pesca.fecha"
              :sincronized="pesca.sincronizado"
              :opaque="pesca.hasOutdatedRecords"
              @click="traerRegistroYNavegar(pesca)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { producerDescription } from '@/utilidades'

export default {
  name: 'Cosechas',
  computed: {
    ...mapState('registros', [
      'pescas',
      'fincas',
      'productores',
      'embarcaciones',
    ]),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Pescas')
  },
  methods: {
    producerDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getPesca', { id: registro.id })
      }
      this.$router.push(`/ru/pesca/${registro.id}`)
    },
  },
}
</script>
<style>
  .tt {
    margin-top: 40px;
    margin-bottom: -20px;
  }
  .lista {
    margin-top: 20px;
  }
</style>
